// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.definitions-tabs {
  display: flex;
  gap: 0;
  margin-top: 24px;
  margin-bottom: 24px;
  border-bottom: 2px solid #e2e8f0;
}

.definitions-tab {
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 600;
  color: #718096;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s;
}

.definitions-tab:hover {
  color: #4a5568;
}

.definitions-tab.active {
  color: #667eea;
  border-bottom-color: #667eea;
}

.definitions-content {
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/Definitions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,MAAM;EACN,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".definitions-tabs {\n  display: flex;\n  gap: 0;\n  margin-top: 24px;\n  margin-bottom: 24px;\n  border-bottom: 2px solid #e2e8f0;\n}\n\n.definitions-tab {\n  padding: 12px 24px;\n  font-size: 15px;\n  font-weight: 600;\n  color: #718096;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -2px;\n  cursor: pointer;\n  transition: color 0.2s, border-color 0.2s;\n}\n\n.definitions-tab:hover {\n  color: #4a5568;\n}\n\n.definitions-tab.active {\n  color: #667eea;\n  border-bottom-color: #667eea;\n}\n\n.definitions-content {\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
